import styled from "styled-components";
import { breakpoints } from "styles/grid";
import Block from "components/layout/Block";

const StyledPresentationTemplateContainer = styled(Block)`
	padding: 0.5rem 1rem;
	min-height: 50px;

	@media (max-width: ${breakpoints.phone - 1}px) {
		padding: 0;
		min-height: unset;
	}
`;

export default StyledPresentationTemplateContainer;
